/**
 * Resource that represent a CycleCountItem.
 *
 * @name CycleCountItem
 * @class
 * @augments TmrResource
 */
function CycleCountItemFactory(TmrApi, TmrResource, User, CycleCount) {
  'ngInject'
  let actions = {
    aggregatedCount: {
      method: 'GET',
      url: TmrApi.endpoint('CycleCountItem.aggregatedCount'),
    },
    aggregatedItems: {
      method: 'GET',
      url: TmrApi.endpoint('CycleCountItem.aggregated'),
      isArray: true,
    },
    aggregatedExport: {
      method: 'GET',
      url: TmrApi.endpoint('CycleCountItem.aggregatedExport'),
    },
  }

  let referencedProperties = [
    { property: 'readBy', resource: User },
    { property: 'count', resource: CycleCount },
  ]

  let CycleCountItem = TmrResource(
    'CycleCountItem',
    actions,
    referencedProperties
  )

  return CycleCountItem
}

export const factory = ['CycleCountItem', CycleCountItemFactory]
